<ag-grid-angular
   [ngClass]="this.cssClassForGrid"
   [gridOptions]="this.gridOptions"
   >
</ag-grid-angular>
 
 <ets-adjustment-solution-popup [readOnly]="true">
 </ets-adjustment-solution-popup>